import { useEffect, useState, useContext } from "react";
import { Button } from "reactstrap";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import { ProjectVersionModal } from "../Modals/ProjectVersionModal/ProjectVersionModal";
import GenericListContainer from "../GenericList/GenericListContainer";
import {
  GET_LOGIN_DATA,
  GET_PROJECT_VERSION,
  FIND_PROJECT,
} from "../GraphQl/query";
import { duplicateResponse } from "../Helpers/functions";
import { ORGVERSION, PROJECTSBYSTRUCTUREYEAR } from "../../navigation/Routes";
import {
  getDefaultStartDate,
  getDefaultEndDate,
} from "../Modals/ProjectVersionModal/functions";
import { AddButton } from "../CommonComponents";
import { PageWrapper } from "../PageWrapper/PageWrapper";
import { ADMIN, MOH } from "../Helpers/constants";
import { ProjectContext } from "../ProjectProvider";

const toOrgVersion = (projectVersionId, navigate, project) => {
  navigate(`${ORGVERSION}/${projectVersionId}`, {
    state: {
      projectVersionDesc: project.description,
      hasUnits: project.project.structure.hasUnits,
      from: "prjVersion",
    },
  });
};

const ProjectVersionContainer = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const { state } = useLocation();
  const projectCode = state?.projectCode;
  const developer = state?.developer;
  const missingheader = state?.missingheader;
  const project = state?.project;

  const { projectData } = useContext(ProjectContext);

  const { t } = useTranslation();
  const [modalState, toggleModalState] = useState(false);
  const [values, setValues] = useState();
  const [isUpdate, setIsUpdated] = useState(false);
  const [projectVersionList, setProjectVersionList] = useState([]);
  const [projectVersion, setProjectVersion] = useState({});

  const { data: auth } = useQuery(GET_LOGIN_DATA);
  const userRole = auth?.userInfo.role;
  const isMinistry = userRole === MOH;
  const restrictActions = [MOH, ADMIN].includes(userRole);

  const { data, loading, error } = useQuery(GET_PROJECT_VERSION, {
    variables: { projectId, includeInactive: true },
  });
  const { data: dataProject } = useQuery(FIND_PROJECT, {
    variables: { projectId },
  });

  useEffect(() => {
    if (data?.result) {
      setProjectVersionList(duplicateResponse(data?.result));
    }
  }, [data]);

  useEffect(
    () => {
      if (dataProject) {
        const project = dataProject.result ? dataProject.result : {};
        var data = { ...projectVersion };
        data.project = project;
        data.active = true; // Settato Ad Attivo Per Default E Poi Nascosto
        data.startPeriodDate = getDefaultStartDate(data, projectVersionList);
        data.endPeriodDate = getDefaultEndDate(data);
        data.projectId = project.id;
        data.versionType = "";
        data.description = "";
        setProjectVersion(data);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataProject],
  );

  const getAditionalMethod = (original) => {
    if (original.active) {
      setValues(original);
      setIsUpdated(true);
      toggleModalState(true);
    } else {
      navigate(
        `${PROJECTSBYSTRUCTUREYEAR}/${original.project.code}?projectId=${projectVersion.projectId}`,
      );
    }
  };

  const TableHeader = (
    <AddButton
      toggleModalState={toggleModalState}
      action={() => {
        setIsUpdated(false);
        setValues({
          ...projectVersion,
          startPeriodDate: null,
          endPeriodDate: null,
        });
      }}
    />
  );

  const additionalColumns = [
    {
      accessor: "organizationVersions",
      show: !isMinistry,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Button
          color={"info"}
          onClick={() => {
            toOrgVersion(row.original.id, navigate, row.original);
          }}
        >
          {t("orgVersion")}
        </Button>
      ),
    },
    {
      accessor: "update",
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Button
          hidden={restrictActions && row.original.active}
          onClick={() => {
            getAditionalMethod(row.original);
          }}
        >
          {row.original.active ? t("mod") : t("redirect")}
        </Button>
      ),
    },
  ];

  return (
    <PageWrapper loading={loading} error={error}>
      {modalState && (
        <ProjectVersionModal
          toggleModal={toggleModalState}
          modalState={modalState}
          list={projectVersionList}
          translate={t}
          values={values}
          isUpdate={isUpdate}
        />
      )}

      <GenericListContainer
        list={projectVersionList}
        structureName={"ProjectVersion"}
        parentValue={projectCode}
        developer={developer}
        missingheader={missingheader}
        project={project}
        TableHeader={restrictActions ? null : TableHeader}
        additionalColumns={additionalColumns}
        projectDates={{
          projectCode: projectData?.code,
          versionEndingDate: projectData?.endingDate,
          versionStartingDate: projectData?.startingDate,
          projectEndingDate: projectData?.projectEndingDate,
          projectStartingDate: projectData?.projectStartingDate,
          projectExtensionDate: projectData?.projectExtensionDate,
        }}
      />
    </PageWrapper>
  );
};

export default ProjectVersionContainer;
